import {SignUpDTO} from '@/domain/dtos/SignUpDTO';
import {Ban} from '@/domain/models/Ban';
import {signOut} from '@/entities/user/api/signOut';
import {sendCampaignIfExists} from '@/features/campaign/api';
import {deleteToken} from '@/shared/lib/firebase';
import {getAuthToken, setAuthToken} from '@/shared/lib/localStorage/authToken';
import {clearLocalStorage} from '@/shared/lib/localStorage/clearLocalStorage';
import {getFirebaseToken} from '@/shared/lib/localStorage/firebase';
import {clearSignUpInfo} from '@/shared/lib/localStorage/signUp/signUpInfo';
import {afterSignUp} from '@/sync/actions/afterSignUp';
import {localizeHref} from '@/sync/lib/localizeHref';

export async function clearUserData() {
  if (getFirebaseToken()) {
    await deleteToken();
  }

  clearLocalStorage();
}

export const handleSignOut = async ({ban}: {ban?: Ban} = {}) => {
  if (getAuthToken()) {
    await signOut();
  }

  await clearUserData();

  if (!ban) {
    window.location.href = localizeHref('/:lang?');
    return;
  }

  window.location.href = `${localizeHref('/:lang?/error-banned')}?banId=${ban.id}&userId=${ban.user_id}&until=${ban.until}`;
};

export const handleLoginSuccess = (loginResponse: SignUpDTO) => {
  clearSignUpInfo();
  const token = loginResponse.token.access;
  const {home} = loginResponse;

  if (token && home) {
    setAuthToken(token);
    sendCampaignIfExists();
    afterSignUp();
    return true;
  }

  return false;
};
